import { AttachLinkButton } from './interactive-response-attach-audio.style';

const InteractiveResponseAttachAudio = ({
  audioFileName,
  onClick,
}: {
  audioFileName: string | null;
  onClick: () => void;
}) => {
  return (
    <AttachLinkButton
      type="button"
      $fontWeight="medium"
      onClick={onClick}
      data-selector={
        audioFileName ? 'success-audio-upload' : 'btn-attach-sound'
      }
    >
      {audioFileName ? audioFileName : 'Attach Sound'}
    </AttachLinkButton>
  );
};

export default InteractiveResponseAttachAudio;
